(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[90977],{

/***/ 51213:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/goal/[goalSlug]/[goalUID]/free-platform",
      function () {
        return __webpack_require__(29153);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 29153:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ free_platform; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./node_modules/swr/infinite/dist/index.mjs
var infinite_dist = __webpack_require__(44593);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(95934);
// EXTERNAL MODULE: ./src/components/Base/Paper/Paper.jsx
var Paper = __webpack_require__(59485);
// EXTERNAL MODULE: ./src/components/Base/H2/H2.jsx
var H2 = __webpack_require__(39396);
// EXTERNAL MODULE: ./src/components/Base/Image.jsx
var Image = __webpack_require__(80867);
// EXTERNAL MODULE: ./src/api/hooks/topology/useTopology.js
var useTopology = __webpack_require__(71609);
// EXTERNAL MODULE: ./src/styleConstants/index.js
var styleConstants = __webpack_require__(2080);
;// CONCATENATED MODULE: ./src/components/Container/FreePlatformCourse/TopBlock.jsx








var StyledPaper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(Paper/* default */.Z, {
    target: "e13zefg50",
    label: "StyledPaper"
})("display:flex;");
var GoalImage = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e13zefg51",
    label: "GoalImage"
})("position:relative;height:64px;width:64px;");
var StyH2 = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(H2/* default */.Z, {
    target: "e13zefg52",
    label: "StyH2"
})("margin:0;margin-left:", styleConstants/* Spacings.SPACING_10B */.t8.FC, ";align-self:center;color:var(--color-text-primary);");
var TopBlock = function() {
    var router = (0,next_router.useRouter)();
    var goalUID = router.query.goalUID;
    var ref = (0,useTopology/* default */.Z)(goalUID, {
        revalidateOnMount: false
    }), goalTopology = ref.topology;
    var icon = goalTopology.icon, name = goalTopology.name;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledPaper, {
        gridColumn: "span 18",
        padding: "".concat(styleConstants/* Spacings.SPACING_10B */.t8.FC, " ").concat(styleConstants/* Spacings.SPACING_12B */.t8.SL),
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GoalImage, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image["default"], {
                    src: icon,
                    alt: name,
                    layout: "fill"
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyH2, {
                children: name
            })
        ]
    });
};
/* harmony default export */ var FreePlatformCourse_TopBlock = (TopBlock);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/Base/CircularLoader/CircularLoader.jsx
var CircularLoader = __webpack_require__(13909);
// EXTERNAL MODULE: ./src/components/Container/SWRInfiniteFeedRow/InfiniteFeedRow.jsx
var InfiniteFeedRow = __webpack_require__(5015);
// EXTERNAL MODULE: ./src/components/Container/SWRInfiniteFeedRow/DynamicFeedTypeBlock.jsx + 1 modules
var DynamicFeedTypeBlock = __webpack_require__(2252);
// EXTERNAL MODULE: ./src/components/Container/SWRInfiniteFeedRow/utils/getBlockType.js
var getBlockType = __webpack_require__(58483);
// EXTERNAL MODULE: ./src/api/selectors/auth.js
var auth = __webpack_require__(73060);
// EXTERNAL MODULE: ./src/api/hooks/auth/useMyInfo.js
var useMyInfo = __webpack_require__(85780);
// EXTERNAL MODULE: ./src/components/Container/SWRInfiniteFeedRow/useInfiniteFeedRow.js + 9 modules
var useInfiniteFeedRow = __webpack_require__(5700);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/api/fetchers/index.js
var fetchers = __webpack_require__(19982);
// EXTERNAL MODULE: ./src/utils/api-helper/host.js
var host = __webpack_require__(54051);
;// CONCATENATED MODULE: ./src/api/fetchers/free-platform/index.js




var defaultHost = (0,host/* getHost */.XF)();
var getFeedAPI = function(param) {
    var goalUID = param.goalUID, _limit = param.limit, limit = _limit === void 0 ? 3 : _limit, _offset = param.offset, offset = _offset === void 0 ? 0 : _offset;
    return "".concat(defaultHost, "v1/feeds/user/home_v2/?goal_uid=").concat(goalUID, "&limit=").concat(limit, "&offset=").concat(offset);
};
var fetchFreePlatformFeed = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
        var goalUID, _limit, limit, _offset, offset;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    goalUID = param.goalUID, _limit = param.limit, limit = _limit === void 0 ? 3 : _limit, _offset = param.offset, offset = _offset === void 0 ? 0 : _offset;
                    return _ctx.abrupt("return", (0,fetchers/* simpleFetch */.l)(getFeedAPI({
                        goalUID: goalUID,
                        limit: limit,
                        offset: offset
                    })));
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function fetchFreePlatformFeed(_) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/components/Container/FreePlatformCourse/useEntireFeed.js


var useEntireFeed = function(param) {
    var goalUID = param.goalUID, _limit = param.limit, limit = _limit === void 0 ? 3 : _limit;
    return (0,useInfiniteFeedRow/* default */.Z)({
        initialURL: getFeedAPI({
            goalUID: goalUID,
            limit: limit
        }),
        swrOptions: {
            revalidateOnMount: false,
            revalidateFirstPage: false
        }
    });
};
/* harmony default export */ var FreePlatformCourse_useEntireFeed = (useEntireFeed);

;// CONCATENATED MODULE: ./src/components/Container/FreePlatformCourse/EntireFeed.jsx














var LoaderWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1aosucw0",
    label: "LoaderWrapper"
})("grid-column:span 18;display:flex;justify-content:center;align-items:center;");
var renderLoader = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LoaderWrapper, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CircularLoader/* default */.Z, {})
    });
};
var EntireFeed = function() {
    var router = (0,next_router.useRouter)();
    var goalUID = router.query.goalUID;
    var isLoggedIn = (0,useMyInfo/* default */.Z)(auth/* getIsLoggedIn */.M7);
    var ref = (0,useTopology/* default */.Z)(goalUID, {
        revalidateOnMount: false
    }), goalTopology = ref.topology;
    var goalSlug = goalTopology.goalSlug;
    var getLinkAndHrefProps = function(type, max, min) {
        var viewAllLink = max > min ? "/goal/".concat(goalSlug, "/").concat(goalUID, "/free-platform/").concat(type) : null;
        var viewAllHref = "/goal/[goalSlug]/[goalUID]/free-platform/[type]";
        return {
            viewAllLink: viewAllLink,
            viewAllHref: viewAllHref
        };
    };
    var ref1 = FreePlatformCourse_useEntireFeed({
        goalUID: goalUID
    }), data = ref1.data, isValidating = ref1.isValidating, refetchEntireFeed = ref1.mutate, fetchMoreData = ref1.fetchMoreData;
    (0,react.useEffect)(function() {
        if (isLoggedIn) {
            refetchEntireFeed();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isLoggedIn
    ]);
    var renderItem = function(feed, index) {
        var feedType = feed.type;
        var feedEntityType = feed.extraBlockinfo.entityType;
        var extraProps = {
            goalSlug: goalSlug,
            goalUID: goalUID,
            index: index,
            goal: goalTopology,
            lastPrimarySource: "Old Courses Home",
            type: "freeCourse",
            dataAnalytics: "freePlatform"
        };
        if ((0,getBlockType/* isCourseEntityType */.Mm)(feedEntityType)) {
            var ref;
            var feedCount = ((ref = feed.extraBlockinfo) === null || ref === void 0 ? void 0 : ref.count) || 0;
            extraProps = (0,_object_spread/* default */.Z)({}, extraProps, getLinkAndHrefProps(feedType, feedCount, 3));
        }
        if ((0,getBlockType/* isEducatorEntityType */.vr)(feedEntityType)) {
            var ref1;
            var feedCount1 = ((ref1 = feed.extraBlockinfo) === null || ref1 === void 0 ? void 0 : ref1.count) || 0;
            extraProps = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, extraProps, getLinkAndHrefProps(feedType, feedCount1, 0)), {
                useLeaderboardMetaInfo: true
            });
        }
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DynamicFeedTypeBlock/* default */.Z, (0,_object_spread/* default */.Z)({
            feedBlock: feed
        }, extraProps), feedType);
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InfiniteFeedRow/* default */.Z, {
        data: data.results,
        isLoading: isValidating,
        renderItem: renderItem,
        renderLoader: renderLoader,
        onLoadMore: fetchMoreData
    });
};
/* harmony default export */ var FreePlatformCourse_EntireFeed = (EntireFeed);

;// CONCATENATED MODULE: ./src/components/Container/FreePlatformCourse/FreePlatformCourse.jsx



var FreeCourse = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FreePlatformCourse_TopBlock, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FreePlatformCourse_EntireFeed, {})
        ]
    });
};
/* harmony default export */ var FreePlatformCourse = (FreeCourse);

;// CONCATENATED MODULE: ./src/seo/FreeCourseSD.jsx
var FreeCourseSD = function(goalData, freeFeedOfGoal) {
    if (!freeFeedOfGoal) return null;
    var courseList = {
        "@context": "http://schema.org",
        "@type": "ItemList",
        url: null,
        numberOfItems: "45",
        itemListElement: []
    };
    var pos = 0;
    var results = freeFeedOfGoal.results;
    results.forEach(function(feedBlock) {
        var ref, ref1;
        var feedType = (ref = feedBlock.extraBlockinfo) === null || ref === void 0 ? void 0 : (ref1 = ref.id) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase();
        if (feedType === "courses" || feedType === "course" || feedType === "courses_big" || feedType === "my_classes" || feedType === "programme" || feedType === "popular_courses") {
            var courses = feedBlock.courses;
            courses.forEach(function(course) {
                var permalink = course.permalink, name = course.name, description = course.description, thumbnail = course.thumbnail, uid = course.uid, authors = course.authors, forPlus = course.forPlus, language = course.language;
                if (!courseList.url) courseList.url = permalink;
                var author = authors[0];
                var authName = author.name, authThumbnail = author.thumbnail, bio = author.description;
                var courseObject = {
                    "@type": "Course",
                    "@id": permalink,
                    position: pos,
                    name: name,
                    url: permalink,
                    about: description,
                    description: description,
                    thumbnailUrl: thumbnail,
                    courseCode: uid,
                    accessMode: [
                        "auditory",
                        "visual"
                    ],
                    author: {
                        "@type": "Person",
                        "@id": uid,
                        name: authName,
                        image: authThumbnail,
                        description: bio,
                        jobTitle: "Educator"
                    },
                    isAccessibleForFree: forPlus ? "False" : "True",
                    inLanguage: language,
                    provider: {
                        "@type": "Organization",
                        name: "Unacademy",
                        sameAs: "https://unacademy.com/"
                    }
                };
                courseList.itemListElement.push(courseObject);
                pos += 1;
            });
        }
    // return courseList;
    });
    courseList.numberOfItems = courseList.itemListElement.length;
    return courseList;
};
/* harmony default export */ var seo_FreeCourseSD = (FreeCourseSD);

// EXTERNAL MODULE: ./src/layout/index.jsx + 26 modules
var layout = __webpack_require__(41566);
// EXTERNAL MODULE: ./src/components/Container/App/PageReduxProviderWrapper.jsx
var PageReduxProviderWrapper = __webpack_require__(27300);
// EXTERNAL MODULE: ./src/stores/sidenav.js
var sidenav = __webpack_require__(19204);
// EXTERNAL MODULE: ./src/seo/index.jsx + 2 modules
var seo = __webpack_require__(14432);
// EXTERNAL MODULE: ./src/constants/segment.js
var segment = __webpack_require__(17579);
;// CONCATENATED MODULE: ./src/pages/goal/[goalSlug]/[goalUID]/free-platform.jsx
















var FreeLiveClassesPageWithSEO = function() {
    var router = (0,next_router.useRouter)();
    var goalUID = router.query.goalUID;
    var ref = (0,useTopology/* default */.Z)(goalUID), goalTopology = ref.topology;
    var data = FreePlatformCourse_useEntireFeed({
        goalUID: goalUID
    }).data;
    var goalSlug = goalTopology.goalSlug, title = goalTopology.title, uid = goalTopology.uid, ogImage = goalTopology.ogImage;
    var goalTitle = "Prepare for ".concat(title, " from India\u2019s best Educators.");
    var goalDescription = "Prepare for ".concat(title, " from Top Educators with comprehensive, structured and crash courses along with practice section for ").concat(title, " for free.");
    var canonicalURL = "https://unacademy.com/goal/".concat(goalSlug, "/").concat(uid, "/free");
    var imageURL = ogImage || "https://static.uacdn.net/static/dist/c76c2e18c7980818a913f9467c74c567.png";
    (0,sidenav/* useSetSelectedNav */.WF)("free-platform");
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(seo/* default */.Z, {
                title: goalTitle,
                description: goalDescription,
                openGraph: {
                    title: goalTitle,
                    description: goalDescription,
                    images: [
                        {
                            url: imageURL
                        }
                    ],
                    url: canonicalURL
                },
                schema: seo_FreeCourseSD(goalTopology, data)
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((head_default()), {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("title", {
                    children: goalTitle
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FreePlatformCourse, {})
        ]
    });
};
var FreeCoursePageWithSWRConfig = function(param) {
    var platformFeedFallbackData = param.platformFeedFallbackData, goal = param.goal;
    var key = (0,infinite_dist/* unstable_serialize */.wE)(function() {
        return getFeedAPI({
            goalUID: goal.uid
        });
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* SWRConfig */.J$, {
        value: {
            revalidateOnMount: false,
            dedupingInterval: 60 * 1000,
            fallback: (0,_define_property/* default */.Z)({}, key, [
                platformFeedFallbackData
            ])
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FreeLiveClassesPageWithSEO, {})
    });
};
FreeCoursePageWithSWRConfig.Layout = layout/* default */.Z;
FreeCoursePageWithSWRConfig.Wrapper = PageReduxProviderWrapper["default"];
FreeCoursePageWithSWRConfig.pageInfo = {
    isMWebSupported: true,
    name: segment/* OTHER_COURSES */.e8c,
    layoutOptions: {
        showPlusNav: true
    }
};
var __N_SSG = true;
/* harmony default export */ var free_platform = (FreeCoursePageWithSWRConfig);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [53662,35303,86924,82492,52420,25675,96523,61608,41664,63953,74635,55169,86985,2291,73664,20561,9720,46571,89374,94336,4392,72047,56015,41566,48392,39166,55033,30038,94142,25584,49774,92888,40179], function() { return __webpack_exec__(51213); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);